import React, { useEffect, useState } from "react";
import Geocode from "react-geocode";
// import ("dotenv").config();

export default function App() {
  const [values, setValues] = useState("hi");
  const [temp, setTemp] = useState(0);
  const [lat, setLat] = useState(0);
  const [long, setLong] = useState(0);
  const [temps,setTemps] = useState([]);
  const [data, setData] =useState([]);
 
  const dateStr = [];
  
  let input = [];

  useEffect(() => 
  {
  const fetcData = ()=>
  {
    
    navigator.geolocation.getCurrentPosition(function (position)
     {
      Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API);
// set response language. Defaults to english.
Geocode.setLanguage("en");
       console.log(position);
      setLat(position.coords.latitude);
      setLong(position.coords.longitude);
   
    
   let lats = position.coords.latitude;
   let longs =  position.coords.longitude;
    Geocode.fromLatLng(lats, longs).then(
      (response) => 
      {
        const address = response.results[0].formatted_address;
        let city, state, country;
        for (let i = 0; i < response.results[0].address_components.length; i++) {
          for (let j = 0; j < response.results[0].address_components[i].types.length; j++) {
            switch (response.results[0].address_components[i].types[j]) {
              case "locality":
                city = response.results[0].address_components[i].long_name;
                break;
              case "administrative_area_level_1":
                state = response.results[0].address_components[i].long_name;
                break;
              case "country":
                country = response.results[0].address_components[i].long_name;
                break;
            }
          }
        }
        api(state);
        
      },
      (error) => {
        console.error(error);
      }
    );
    
     });
    
  }
  //fetching weather and coverting temp to cel
  const api = (city)=>{
    fetch(
      `https://api.openweathermap.org/data/2.5/forecast?q=${city}&appid=${process.env.REACT_APP_WEATHER_API}`
    )
      .then((response) => response.json())
      .then((data) => {
        input.push(data);
        setValues(input[0].city.name);
        setTemp((data.list[0].main.temp - 273.15).toFixed(2));
        console.log(input);
        console.log((data.list[0].main.temp - 273.15).toFixed(3));
       });
      }
  
      fetcData();
  }, [input]);

//time-calculation
  const formatAMPM = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes.toString().padStart(2, "0");
    let month = date.toLocaleString("default", { month: "short" });
    let day = date.getDate();
    let strTime = `${hours}:${minutes}${ampm}, ${month} ${day}`;
    return strTime;
  };
  const time = formatAMPM(new Date());

//date-format-3days weather forecast
  const foreCast = () => {
      console.log("object")
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const days = [];
    for(let  i = 1 ;i<=3;i++){
days.push((day + i).toString().padStart(2,"0"));
    }  
    let crrDate = `${year}-${month+1}-${day.toString().padStart(2,"0")}`;
    const dates = [];
    for(let i =0 ;i<days.length;i++){
        dates.push(`${year}-${month+1}-${days[i]}`)
    }
   const temp = [];
  dates.forEach((date)=>{
      const temps = [];
        input[0].list.forEach((dat)=>{
            if(dat.dt_txt.includes(date)){
                temps.push((dat.main.temp-273.15).toFixed(2));
                
            }
            });
            temp.push(Math.min(...temps));
    })
    //getting days name
    setTemps(temp);
    const dayName = ['Sun','Mon',"Tue",'Wed','Thu','Fri','Sat'];
    const week = date.toLocaleDateString('default',{weekday:"short"})
    const dayno = date.getDay();
    let count = 0;
    const weekdays = [];
    for(let i =dayno+1;i<=dayName.length;i++){
        if(count === 3){
          break;
        }if(i === 6 & count !== 3){
        
          i = 0;
        }
        weekdays.push(dayName[i]);
        count++;
    }
    let str = '';
    
    for(let i =0 ;i<3;i++){
        str = `${weekdays[i]}, ${date.toLocaleString("default", { month: "short" })} ${days[i]}`
        dateStr.push(str);
    }
    setData(dateStr);
    
  };
//displaying and designing
  return (
    <div className="container-fluid">
      <div className = "row justify-content-center">
        <div className="col-sm-6 col-md-6 d-flex justify-content-center flex-column text-center">
      <h6 className="text-secondary">{time}</h6>
      <h2>{values}</h2>

      <h1 className={temp>30?'text-danger':'text-info'}>
        {temp}
        <sup>o</sup>&nbsp;C
      </h1>
      <button onClick={foreCast}>Next 3 Days Forecast</button>
     <div className="row m-3 p-2">
      <div className="col-md-6 col-sm-6"> {data.length === 0 ? "" :
      data.map((dat,id)=><h5 key={id}>{dat}</h5>)
      }</div>
     <div className="col-md-4 col-sm-4">
     {temps.length === 0 ? "" :
      temps.map((dat,id)=><h5 key={id}>{dat}<sup>o</sup>&nbsp;C</h5>)
      }
     </div>
     </div>
     </div>
     <div className="col-sm-6 col-md-6 pt-5">
      <img src={`https://maps.googleapis.com/maps/api/staticmap?center=${lat},${long}&zoom=14&size=400x300&sensor=false&markers=color:red%7C${lat},${long}&key=${process.env.REACT_APP_GOOGLE_API}`}></img>
      </div>
      </div>
    </div>
  );
}